/* Hard-coded dates compared against each employee's lastAccepted from
 * useGetV2EmployeeAgreementsTos and useGetV2EmployeeAgreementsPrivacy.
 * Anyone who accepted before the date is gated until they re-accept.
 * Must match the "As of" date printed in the published PDF (legal-record repo).
 */
export const PRIVACY_POLICY_LAST_UPDATED = "2024-08-20";

export const TERMS_OF_SERVICE_LAST_UPDATED = "2026-10-23";
